import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, Injectable } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { DataProvider } from '../providers/data/data';
import { HttpClientModule } from '@angular/common/http';
import { CombinedResultsPage } from '../pages/combined-results/combined-results';
import { DrugCategoryPage } from '../pages/drug-category/drug-category';
import { CombinedResultsPageModule } from '../pages/combined-results/combined-results.module';
import { DrugCategoryPageModule } from '../pages/drug-category/drug-category.module';
import { AnalyticsProvider } from '../providers/analytics/analytics';
import { TermsAndConditionsPageModule } from '../pages/terms-and-conditions/terms-and-conditions.module';
import { SettingsProvider } from '../providers/settings/settings';
import { TermsAndConditionsPage } from '../pages/terms-and-conditions/terms-and-conditions';
import { DrugDetailPage } from '../pages/drug-detail/drug-detail';
import { DrugDetailPageModule } from '../pages/drug-detail/drug-detail.module';
import { ShareProvider } from '../providers/share/share';
import { ComponentsModule } from '../components/components.module';
import { NameSurveyProvider } from '../providers/name-survey/name-survey';
import { AdvancedSearchPage } from '../pages/advanced-search/advanced-search';
import { AdvancedSearchPageModule } from '../pages/advanced-search/advanced-search.module';
import { DrugDataStore } from '../providers/data/drug-data-store';
import { DataStore } from '../providers/data/data-store';
import { ImpressumPage } from '../pages/impressum/impressum';
import { ImpressumPageModule } from '../pages/impressum/impressum.module';
import { AboutPageModule } from '../pages/about/about.module';
import { TransferDataPageModule } from '../pages/transfer-data/transfer-data.module';
import { TransferDataPage } from '../pages/transfer-data/transfer-data';



@Injectable()
export class InjectableDrugDataStore extends DrugDataStore {
  constructor() {
    super(new DataStore())
  }
}

@NgModule({
  declarations: [
    MyApp,
    HomePage,
  ],
  imports: [
    BrowserModule,
    ComponentsModule,
    CombinedResultsPageModule,
    DrugCategoryPageModule,
    DrugDetailPageModule,
    AdvancedSearchPageModule,
    ImpressumPageModule,
    AboutPageModule,
    TermsAndConditionsPageModule,
    TransferDataPageModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    CombinedResultsPage,
    DrugCategoryPage,
    DrugDetailPage,
    AdvancedSearchPage,
    ImpressumPage,
    TermsAndConditionsPage,
    TransferDataPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    DataProvider,
    { provide: DrugDataStore, useClass: InjectableDrugDataStore },
    AnalyticsProvider,
    SettingsProvider,
    ShareProvider,
    NameSurveyProvider
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts